import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { WhatsAppButton } from "../WhatsAppButton";
import { AccessibilityWidget } from "../AccessibilityWidget";
import { DynamicBreadcrumbs } from "../DynamicBreadcrumbs";
import CookieConsent from "../CookieConsent";
import { useMaintenanceMode } from "@/hooks/useMaintenanceMode";
import { useAdminCheck } from "@/hooks/useAdminCheck";
import MaintenancePage from "@/pages/MaintenancePage";
import { PlaneLoader } from "../PlaneLoader";

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const maintenance = useMaintenanceMode();
  const { isAdmin, isLoading: adminLoading } = useAdminCheck();

  // Show loader while checking maintenance and admin status
  if (maintenance.loading || adminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <PlaneLoader />
      </div>
    );
  }

  // If maintenance mode is enabled and user is not admin, show maintenance page
  if (maintenance.enabled && !isAdmin) {
    return <MaintenancePage message={maintenance.message} />;
  }

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Header />
      {!isHomePage && <DynamicBreadcrumbs />}
      <main className="flex-1" role="main">{children}</main>
      <Footer />
      <MobileNav />
      <WhatsAppButton />
      <AccessibilityWidget />
      <CookieConsent />
    </div>
  );
};
